// src/components/location/DirectionsInfo.js
import React from 'react';
import { Link } from 'react-router-dom';

const ContactItem = ({ icon, title, children }) => (
  <div className="flex space-x-4 items-start">
    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <div>
      <h3 className="font-semibold text-white mb-1">{title}</h3>
      <div className="text-gray-300">{children}</div>
    </div>
  </div>
);

const DirectionsInfo = () => {
  return (
    <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-8">
      <div className="space-y-8">
        {/* Address */}
        <ContactItem
          icon={
            <svg className="w-6 h-6 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          }
          title="Adres"
        >
          <p>ul. Ignacego Matuszewskiego 11A</p>
          <p>80-288 Gdańsk</p>
        </ContactItem>

        {/* Opening hours */}
        <ContactItem
          icon={
            <svg className="w-6 h-6 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          }
          title="Godziny otwarcia"
        >
          <div className="grid grid-cols-2 gap-2">
            <div>
              <p>Poniedziałek - Piątek</p>
              <p>Sobota</p>
              <p>Niedziela</p>
            </div>
            <div>
              <p>9:00 - 18:00</p>
              <p>9:00 - 16:00</p>
              <p>nieczynne</p>
            </div>
          </div>
        </ContactItem>

        {/* Contact */}
        <ContactItem
          icon={
            <svg className="w-6 h-6 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          }
          title="Kontakt"
        >
          <p>Tel: <a href="tel:+48508198200" className="hover:text-primary-400 transition-colors">+48 508 198 200</a></p>
          <p>Email: <a href="mailto:mdclean@interia.pl" className="hover:text-primary-400 transition-colors">mdclean@interia.pl</a></p>
        </ContactItem>

        {/* Parking */}
        <div className="space-y-4">
          <div className="flex items-start space-x-2">
            <svg className="w-6 h-6 text-primary-400 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
            </svg>
            <p className="text-gray-300">Parking dostępny bezpośrednio przed budynkiem.</p>
          </div>
        </div>

        {/* CTA */}
        <div className="pt-4">
          <Link
            to="/contact"
            className="block w-full py-3 px-4 text-center rounded-xl bg-primary-600 text-white font-medium
                     hover:bg-primary-700 transition-colors duration-300
                     focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Umów wizytę
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DirectionsInfo;
